import { useTranslation } from "react-i18next";

/**
 * AnswerClosedScreen — 回答期間終了により提出が拒否された場合の案内画面 (ADR-0032)。
 *
 * SurveyForm が POST /api/respondent-answers の 409 (detail: "answer period closed") を
 * 検知したときに表示する。トークン自体は有効なまま回答期限だけを過ぎたケースであり、
 * 「再送すれば回答できる」トークン期限切れ (RespondPage の invalid 表示) とは違い、
 * 再送しても回答できないことが伝わる文言にする (提出済み SubmittedScreen とも文脈が違う)。
 */
export function AnswerClosedScreen() {
  const { t } = useTranslation("respond");
  return (
    <section className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-base font-semibold">{t("answerClosed.title")}</h2>
        <p className="text-sm text-muted-foreground">{t("answerClosed.description")}</p>
      </header>
    </section>
  );
}
